import { ErrorHandler, Injectable, NgZone } from "@angular/core";
import { ErrorDialogService } from "../../shared/services/error-dialog.service";
import {NGXLogger} from "ngx-logger";
import {environment} from "../../../environments/environment";

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private errorDialogService: ErrorDialogService,
              private logger: NGXLogger,
              private zone: NgZone) {}

  handleError(error: Error) {
      this.zone.run(() => {
        if (environment.show_error_dialogs) {
          this.errorDialogService.openDialog(
          error.message || "Undefined client error");
        }
      });

    this.logger.error("Error from global error handler", error);
  }
}
